module.exports = __webpack_public_path__ + "static/media/4.0d557f9f.webp";